import React from 'react';
import { Input, InputProps } from '../Input';
import { IconSvg } from '../../common/IconSvg';
import { Button } from '../../common/Button';

interface State {
  isVisiblePassword: boolean;
}

export class InputPassword extends React.Component<InputProps> {
  public state: State = {
    isVisiblePassword: false
  };

  toggleVisiblePassword = () => {
    this.setState((prevState: State) => ({
      isVisiblePassword: !prevState.isVisiblePassword
    }));
  };

  public render() {
    return (
      <Input
        {...this.props}
        type={this.state.isVisiblePassword ? 'text' : 'password'}
        autoComplete="off"
        icon={
          <Button
            as="label"
            view="transparent"
            shape="circle"
            htmlFor={this.props.id}
            onClick={this.toggleVisiblePassword}
            data-testid="input-password-icon"
          >
            <IconSvg src={this.state.isVisiblePassword ? 'eye-open' : 'eye-closed'} />
          </Button>
        }
      />
    );
  }
}
